import React from 'react';
import {FilterBar} from "../../../components/Grid/FilterBar";
import {useTranslation} from "react-i18next";
import {format} from "date-fns";
import Grid from "@material-ui/core/Grid";
import {DateRangeFilter} from "../../../components/DateRangeFilter";

export const Filter = ({filter, onUpdateFilter, sort, onFilterChanged, onSortChanged}) => {

	const {t}  = useTranslation();

	const sortOptions = [
      {
        value: 'Id|desc',
        label: t('Newest first')
      },
      {
        value: 'Id|asc',
        label: t('Oldest first')
      }
    ];

    return (
            <Grid>
              <FilterBar showQuerySearch={true} sortOptions={sortOptions} onFilterChanged={onFilterChanged} onSortChanged={onSortChanged} filter={filter} sort={sort}>
                  <Grid item xs={3}>
                      <DateRangeFilter value={filter.DateFrom && filter.DateTo ? { startDate: new Date(filter.DateFrom), endDate: new Date(filter.DateTo) } : null} onChange={e => { onUpdateFilter(null, { 'DateFrom': format(e.startDate, 'yyyy-MM-dd'), 'DateTo': format(e.endDate, 'yyyy-MM-dd') }); }} />
                </Grid>
              </FilterBar>
           </Grid>);
}